class SetterGetter {
    setObjectPivot(object, pivot) {
        throw new Error("Method not implemented");
    }

    getObjectPivot(object, pivot = new THREE.Vector3()) {
        throw new Error("Method not implemented");
    }
}

const inverse = new THREE.Matrix4();
const pivotPos = new THREE.Vector3();

class PivotControls {
    constructor(scene, camera, domElement, setterGetter) {
        this._setterGetter = setterGetter;

        this._scene = scene;
        this._transformControls = new THREE.TransformControls(camera, domElement);
        this._selectedObject = null;
        this._pivotObject = new THREE.Object3D();

        this._updateOnObjectChangeThis = this._updateOnObjectChange.bind(this);
        this._propagateOnWidgetChangeThis = this._propagateOnWidgetChange.bind(this);
        this._propagateOnWidgetGrabThis = this._propagateOnWidgetGrab.bind(this);
        this._propagateOnWidgetReleaseThis = this._propagateOnWidgetRelease.bind(this);

        this._selectEvent = { type: "select", object: null };
        this._widgetChangeEvent = { type: "widgetChange" };
        this._widgetGrabEvent = { type: "widgetGrab" };
        this._widgetReleaseEvent = { type: "widgetRelease" };
        this._events = new THREE.EventDispatcher();
    }

    get events() {
        return this._events;
    }

    selectObject(object) {
        object = object || null;
        this._selectedObject = object;

        if (object) {
            this._scene.add(this._transformControls);
            this._scene.add(this._pivotObject);

            const pivot = this._setterGetter.getObjectPivot(object);
            this._pivotObject.position.copy(pivot).applyMatrix4(object.matrixWorld);

            this._transformControls.attach(this._pivotObject);
            this._transformControls.addEventListener("objectChange", this._updateOnObjectChangeThis);
            this._transformControls.addEventListener("change", this._propagateOnWidgetChangeThis);
            this._transformControls.addEventListener("mouseDown", this._propagateOnWidgetGrabThis);
            this._transformControls.addEventListener("mouseUp", this._propagateOnWidgetReleaseThis);
        } else {
            this._transformControls.removeEventListener("objectChange", this._updateOnObjectChangeThis);
            this._transformControls.removeEventListener("change", this._propagateOnWidgetChangeThis);
            this._transformControls.removeEventListener("mouseDown", this._propagateOnWidgetGrabThis);
            this._transformControls.removeEventListener("mouseUp", this._propagateOnWidgetReleaseThis);
            this._transformControls.detach();

            this._scene.remove(this._transformControls);
            this._scene.remove(this._pivotObject);
        }

        this._selectEvent.object = object;
        this._events.dispatchEvent(this._selectEvent);
        this._selectEvent.object = null;
    }

    getSelectedObject() {
        return this._selectedObject;
    }

    _updateOnObjectChange() {
        const object = this._selectedObject;

        inverse.getInverse(object.matrixWorld);
        pivotPos.copy(this._pivotObject.position).applyMatrix4(inverse);

        this._setterGetter.setObjectPivot(object, pivotPos);
    }

    _propagateOnWidgetChange() {
        this._events.dispatchEvent(this._widgetChangeEvent);
    }

    _propagateOnWidgetGrab() {
        this._events.dispatchEvent(this._widgetGrabEvent);
    }

    _propagateOnWidgetRelease() {
        this._events.dispatchEvent(this._widgetReleaseEvent);
    }
}

export { PivotControls, SetterGetter };
